<template>
  <vue-tags-input
    v-model="input"
    placeholder="Select Language"
    :add-only-from-autocomplete="true"
    :autocomplete-items="filtered"
    :autocomplete-min-length="0"
    :tags="value"
    @tags-changed="(tags) => $emit('input', tags)"
  />
</template>

<script>
import UserClient from '@/api/UserClient';
import { tagFromName } from '@/helpers/tags';
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  name: 'LanguagePicker',

  components: {
    VueTagsInput
  },

  props: {
    value: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      userClient: new UserClient(this.$http),

      input: '',
      choices: []
    };
  },

  computed: {
    filtered() {
      return this.choices.filter(
        (c) =>
          c.text.toLowerCase().indexOf(this.input.toLowerCase()) !== -1 &&
          c.text !== 'English'
      );
    }
  },

  async mounted() {
    this.choices = (await this.userClient.getLanguagesList()).map(tagFromName);
  }
};
</script>
